<template>
    <v-container>
        <v-card>
            <v-card-title style="display: flex;   flex-direction: row;  flex-wrap: nowrap;">
                <span class="font-weight-black text-h6">Lista de Embarcaciones con Responsables</span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                            @click="dialog = true">
                            <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Agregar Nueva Embarcación y Responsable</span>
                </v-tooltip>
            </v-card-title>

            <v-data-table :headers="headers" :items="embarcs" item-value="id" class="elevation-2 custom-table"
                :mobile-breakpoint="0" :items-per-page="15" dense>
                <template v-slot:body="{ items }">
                    <tr v-for="(item, index) in items" :key="item.id" class="hover-row">
                        <td class="id-column">
                            <v-text-field v-if="editIndex === index" v-model="editedItem.id" maxlength="10" dense
                                outlined hide-details></v-text-field>
                            <span v-else>{{ item.id }}</span>
                        </td>
                        <td class="embarcacion-column">
                            <v-text-field v-if="editIndex === index" v-model="editedItem.embarcacion" maxlength="50"
                                dense outlined hide-details></v-text-field>
                            <span v-else>{{ item.embarcacion }}</span>
                        </td>
                        <td class="ejecucion-column">
                            <v-text-field v-if="editIndex === index" v-model="editedItem.ingenieroEjecucion"
                                maxlength="50" dense outlined hide-details></v-text-field>
                            <span v-else>{{ item.ingenieroEjecucion }}</span>
                        </td>
                        <td class="acciones-column text-right">
                            <v-btn v-if="editIndex !== index" icon color="blue" @click="editItem(index, item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn v-if="editIndex === index" icon color="green" @click="saveEdit(index)">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn v-if="editIndex === index" icon color="red" @click="cancelEdit">
                                <v-icon>mdi-cancel</v-icon>
                            </v-btn>
                            <v-btn v-if="editIndex !== index" icon color="red" @click="removeItem(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>

        <!-- Diálogo para agregar nueva embarcación -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>Agregar Nueva Embarcación y Responsable</v-card-title>
                <v-card-text>
                    <v-text-field v-model="newItem.id" label="ID" outlined dense></v-text-field>
                    <v-text-field v-model="newItem.embarcacion" label="Embarcación" outlined dense></v-text-field>
                    <v-text-field v-model="newItem.ingenieroEjecucion" label="Ing. Ejecución" outlined
                        dense></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="addItem">Agregar</v-btn>
                    <v-btn text color="red" @click="dialog = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';

export default {
    data() {
        return {
            dialog: false,
            editIndex: -1,
            editedItem: {},
            newItem: { id: "", embarcacion: "", ingenieroEjecucion: "" },
            embarcs: [],
            headers: [
                { text: "Id", value: "id", align: "center", sortable: true },
                { text: "Embarcación", align: "center", value: "embarcacion", sortable: true },
                { text: "Ing. Ejecución", align: "center", value: "ingenieroEjecucion", sortable: true },
                { text: "Acciones", align: "center", value: "actions", align: "end", sortable: false },
            ],
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        async loadData() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            try {
                const response = await apiService.get("/parameters/get-responsables-embarcacion")
                if (response.data.responsableEmbarcacionList.length > 0) {
                    this.embarcs = response.data.responsableEmbarcacionList;
                } else {
                    this.embarcs = [];
                }
            } catch (error) {
                this.embarcs = [];

            } finally {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
            }

        },
        saveData() {
            localStorage.setItem("embarcs", JSON.stringify(this.embarcs));
        },
        async addItem() {
            if (this.newItem.id && this.newItem.embarcacion && this.newItem.ingenieroEjecucion) {
                //this.embarcs.push({ ...this.newItem });
                const exists = this.embarcs.some(item => item.id === this.newItem.id);

                if (exists) {
                    SwalService.alert('ID Repetido', 'El ID ' + this.newItem.id + ' ya existe, por favor ingresar un ID diferente.');
                    return;
                }
                try {
                    const response = await apiService.post("/parameters/register-responsables-embarcacion", this.newItem)
                    if (response.data.success) {
                        SwalService.success('Embarcación y Responsable asignado', 'Se asignado correctamente el responsable ' + this.newItem.ingenieroEjecucion + ' a la embarcación ' + this.newItem.embarcacion);
                        this.embarcs = response.data.responsableEmbarcacionList;

                    }
                } catch (error) {

                } finally {

                }
                this.dialog = false;
                this.newItem = { id: "", embarcacion: "", ingenieroEjecucion: "" };
            } else {
                SwalService.alert('Campos Incompletos', 'Por favor ingrese todos los campos para poder asignar un responsable a una embarcación.');
                return;
            }
        },
        async removeItem(item) {
            const result = await SwalService.confirm(
                '¿Estás seguro de eliminar la embarcación ' + item.embarcacion + '?',
                'Esta acción eliminará la embarcación.',
                'warning',
                'Sí, eliminar',
                'Cancelar'
            );

            if (result.isConfirmed) {
                // Aquí eliminarías la embarcación
                // this.embarcs = this.embarcs.filter(item => item.id !== id);
                const response = await apiService.post("/parameters/delete-responsables-embarcacion", item)
                if (response.data.success) {
                    SwalService.success('Embarcación y Responsable eliminado', 'Se eliminado correctamente el responsable ' + item.ingenieroEjecucion + ' asociado a la embarcación ' + item.embarcacion);
                    this.embarcs = response.data.responsableEmbarcacionList;
                    Swal.success('Eliminado', 'La embarcación ha sido eliminada.');
                }

            }

        },
        editItem(index, item) {
            this.editIndex = index;
            this.editedItem = { ...item }; // Clonar el objeto para edición
        },
        async saveEdit(index) {
            //this.embarcs[index] = { ...this.editedItem };
            try {
                const response = await apiService.post("/parameters/register-responsables-embarcacion", this.editedItem)
                if (response.data.success) {
                    this.embarcs = response.data.responsableEmbarcacionList;
                }
            } catch (error) {

            } finally {

            }
            //this.saveData();
            this.editIndex = -1;
        },
        cancelEdit() {
            this.editIndex = -1;
        },
    },
};
</script>

<style scoped>
/* Estilos mejorados */
.v-data-table {
    border-radius: 10px;
    overflow: hidden;
}

.v-data-table>>>thead th {
    font-size: 18px !important;
    font-weight: bold;
    text-align: center !important;
    color: white !important;
    background-color: #05435B;
}
.v-data-table>>>thead th.sortable .v-data-table-header__icon {
    color: white !important;
    font-weight: 700;
}

td {
    text-align: center !important;
    border-bottom: 1px solid #ddd;
}

/* Efecto hover para filas */
.hover-row:hover {
    background-color: #f5f5f5;
    transition: background-color 0.3s ease;
}

/* Botón flotante para agregar */
.fab-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
}

.id-column {
    width: 10%;
    text-align: center;
}

.embarcacion-column {
    width: 40%;
    text-align: center;
}

.ejecucion-column {
    width: 40%;
    text-align: center;
}
</style>
